import { DownloadOutlined } from '@ant-design/icons'
import type { ColorPickerProps, GetProp } from 'antd'
import { Button, Card, ColorPicker, QRCode, Space, Typography } from 'antd'
import { useState } from 'react'
import { useTenant } from '../../modules/tenant/contexts/tenant/TenantContext'

const { Title } = Typography
type Color = Extract<
  GetProp<ColorPickerProps, 'value'>,
  string | { cleared: any }
>

const CommunicationQRCode = () => {
  const { tenant } = useTenant()

  function doDownload(url: string, fileName: string) {
    const a = document.createElement('a')
    a.download = fileName
    a.href = url
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
  const downloadSvgQRCode = () => {
    const svg = document
      .getElementById('myqrcode')
      ?.querySelector<SVGElement>('svg')
    const svgData = new XMLSerializer().serializeToString(svg!)
    const blob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' })
    const url = URL.createObjectURL(blob)

    doDownload(url, 'QRCode.svg')
  }
  const [forground, setForground] = useState<Color>('#000')
  const [background, setBackground] = useState<Color>('#fff')
  return (
    <Space orientation="vertical" className="w-full">
      <Space className="w-full space-between">
        <Title level={5} className="m-0">
          <DownloadOutlined /> Download app QR code
        </Title>
      </Space>
      <Card>
        <Space
          orientation="vertical"
          style={{ alignItems: 'center' }}
          className="w-full"
        >
          <QRCode
            id="myqrcode"
            type={'svg'}
            value={`${tenant.appCenterBaseUrl}/download`}
            bgColor={
              typeof background === 'string'
                ? background
                : background?.toHexString()
            }
            color={
              typeof forground === 'string'
                ? forground
                : forground?.toHexString()
            }
            style={{ marginBottom: 16 }}
            size={250}
          />
          <Space className="w-full space-between">
            <Space>
              <ColorPicker value={forground} onChangeComplete={setForground} />
              <ColorPicker
                value={background}
                onChangeComplete={setBackground}
              />
            </Space>
            <Button type="primary" onClick={downloadSvgQRCode}>
              Download
            </Button>
          </Space>
        </Space>
      </Card>
    </Space>
  )
}

type CommunicationQRCodeType = { QRCode: typeof CommunicationQRCode }

export { CommunicationQRCode, type CommunicationQRCodeType }
